import React from 'react';
import PropTypes from 'prop-types';
import utils from "../../utils/utils";
import DATE_FORMAT from "../../components/constants/dateFormat";

const AdminPushNotificationRow = ({pushNotification}) => {
  const dateCreated = utils.getDateFromString(pushNotification.dateCreated).format(DATE_FORMAT.displayWithTime);

  return (
    <tr>
      <th scope="row">
        {pushNotification.id}
      </th>
      <td>
        {pushNotification.title}
      </td>
      <td>
        {pushNotification.content}
      </td>
      <td>
        {pushNotification.triggerForAll? 'Yes': 'No'}
      </td>
      <td>
        {pushNotification.serviceAreas.map(sa => sa.name).join(', ')}
      </td>
      <td>
        {pushNotification.users.join(', ')}
      </td>
      <td>
        {dateCreated}
      </td>
    </tr>
  );
}

AdminPushNotificationRow.propTypes = {
  pushNotification: PropTypes.object.isRequired,
};

AdminPushNotificationRow.defaultProps = {
  pushNotification: {},
};

export default AdminPushNotificationRow;